import {
    AppRedirectionInfo,
    PAYMENT_CODES,
    UPICollectRedirectInfo,
    UPIIntentRedirectInfo,
} from "@swiggy-private/payment-types";

// we only need to handle default values for upi and cred
// for others, if we don't have maxTimeToPollForInMs, we should return 0
// this 0 is compared later in process order to decide if we should poll or not
export function getConfirmationTimeInMinutes(
    upiCollectRedirect?: UPICollectRedirectInfo,
    upiIntentRedirect?: UPIIntentRedirectInfo,
    appRedirectionInfo?: AppRedirectionInfo,
    orderPaymentMethod?: string,
) {
    switch (orderPaymentMethod) {
        case PAYMENT_CODES.UPICOLLECT:
            // read maxTimeToPollForInMs from appRedirectionInfo if available, otherwise use upiIntentConfirmTimeInMs from upiCollectRedirect
            return (
                (appRedirectionInfo?.pollingConfiguration?.maxTimeToPollForInMs ||
                    upiCollectRedirect?.upiIntentConfirmTimeInMs ||
                    60000) / 60000
            );
        case PAYMENT_CODES.UPIINTENT:
            // read maxTimeToPollForInMs from appRedirectionInfo if available, otherwise use upiIntentConfirmTimeInMs from upiIntentRedirect
            return (
                (appRedirectionInfo?.pollingConfiguration?.maxTimeToPollForInMs ||
                    upiIntentRedirect?.upiIntentConfirmTimeInMs ||
                    60000) / 60000
            );
        case PAYMENT_CODES.CRED:
            // read maxTimeToPollForInMs from appRedirectionInfo if available, otherwise use credConfirmTimeInMs from credRedirect
            return (
                (appRedirectionInfo?.pollingConfiguration?.maxTimeToPollForInMs ||
                    appRedirectionInfo?.walletRedirect?.credRedirect?.credConfirmTimeInMs ||
                    60000) / 60000
            );
        default:
            // read maxTimeToPollForInMs from appRedirectionInfo if available, otherwise return 0
            return (appRedirectionInfo?.pollingConfiguration?.maxTimeToPollForInMs || 0) / 60000;
    }
}

export function getPollingIntervalInMs(appRedirectionInfo: AppRedirectionInfo): number | undefined {
    return appRedirectionInfo?.pollingConfiguration?.pollingIntervalInMs;
}
